import { render, staticRenderFns } from "./AiMessageEnhancer.vue?vue&type=template&id=2136156a&scoped=true"
import script from "./AiMessageEnhancer.vue?vue&type=script&lang=js"
export * from "./AiMessageEnhancer.vue?vue&type=script&lang=js"
import style0 from "./AiMessageEnhancer.vue?vue&type=style&index=0&id=2136156a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136156a",
  null
  
)

export default component.exports